import React from "react";
import PillNav from "./pill-nav";
import { siteMap } from "internal-sitemap";
import { t } from "utilities/localization-utils";
import { useLocation } from "react-router";
import useMyLiNKDefaults from "utilities/hooks/domain/my-link/use-my-link-defaults";
import { UserBookmarkCountByFromGroupNameMap } from "utilities/bookmark-utils";

const BookmarksAndCollectionsPillNav = () => {
    const { search } = useLocation();
    const { setDefaultBookmarkViewByPill } = useMyLiNKDefaults();
    const routePills = [
        {
            route: `${siteMap.myLink.myBookmarks.by.all}${search}`,
            label: t("all"),
        },
        {
            route: `${siteMap.myLink.myBookmarks.by.publication}${search}`,
            label: t("publication"),
        },
        {
            route: `${siteMap.myLink.myBookmarks.by.collection}${search}`,
            label: t("collection"),
        },
        {
            route: `${siteMap.myLink.myBookmarks.by.color}${search}`,
            label: t("color"),
        },
    ];
    const handlePillClick = async (label: string) => {
        const newSettingValue =
            UserBookmarkCountByFromGroupNameMap[label.toString().toLowerCase()];
        await setDefaultBookmarkViewByPill(newSettingValue);
    };
    return <PillNav routes={routePills} onPillClick={handlePillClick} />;
};

export default BookmarksAndCollectionsPillNav;
